<div class="flex flex-col gap-4 w-[30rem]" [class]="direction" [ngClass]="isDesktop ? 'w-[30rem]' : 'w-full'">
    <!--
      a11y: top close (X) button, FIRST in DOM with [focusInitial]=true so the
      CDK focus trap places initial focus here on open. Without this, focus
      previously landed on the Delete primary action — a destructive default.
      Now the user must explicitly tab to "Delete" before activating it.
    -->
    <div class="!flex justify-end">
      <mot-button matType="icon" icon="close"
        [ariaLabel]="closeText"
        class="!border-none !w-min !h-min cursor-pointer !bg-transparent" iconClass="!text-2xl"
        [focusInitial]="true"
        (onClick)="closeCard()" />
    </div>

    <p class="text-center">{{deleteFavoriteText}}</p>
    <div class="flex w-full gap-4 justify-center" [ngClass]="{'flex-col' : isMobile}">
        <mot-button [text]="deleteText" buttonClass="!bg-primary !text-white !w-full !rounded-lg !align-middle" (onClick)="deleteFavorite()" [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full' "/>
        <mot-button [text]="cancelText" buttonClass="!border !border-solid !border-[#B4BFCB] !w-full !rounded-lg !align-middle" (onClick)="closeCard()" [ngClass]="isDesktop ? '!w-[13.625rem]' : 'w-full' "/>
    </div>
</div>